/* eslint-disable complexity */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import SegmentHeader from '../../shared/SegmentHeader';
import { withStyles } from '@material-ui/core/styles';
import StepperButtons from '../../shared/StepperButtons';
import {
  initialValuesSanitizer,
  submitOtpSanitizerVoucher,
  submitSanitizer
} from '../../../helpers/sanitizers/portalPromissorySanitizer';
import ActivityIndicator from '../../shared/ActivityIndicator';
import { PdfTypeV2 } from '../../../constants/enums';
import PrimaryButton from '../../shared/Buttons/PrimaryButton';

class DigitalSaleOTPSale extends PureComponent {
  constructor(props) {
    super(props);

    this.setCode = this.setCode.bind(this);
  }

  state = {
    debtorExternalTabOpened: false,
    cosignerExternalTabOpened: false,
    submit: false,
    showOtpValidationModal: false,
    debtorVoucherSignUrl: '',
    debtorVoucherProcessId: ''
  };

  currentStep = this.props.routes.indexOf(this.props.location.pathname);
  nextStep = this.currentStep + 1;

  setCode(code) {
    this.setState({
      code: code
    });
  }

  componentDidMount() {
    this.props.setCurrentStep(this.currentStep);
    this.fetchUnmaterializedVoucher();
  }

  fetchUnmaterializedVoucher = () => {
    const { isRemoteTeleshopping } = this.props;

    const sendOtpFunction = isRemoteTeleshopping
      ? this.props.sendOtpV2Teleshopping
      : this.props.sendOtp;

    const parsedValues = submitOtpSanitizerVoucher(
      PdfTypeV2.voucher,
      this.props
    );

    sendOtpFunction(parsedValues)
      .then(response => {
        if (response && response.debtorVoucherSignUrl) {
          this.setState({
            debtorVoucherSignUrl: response.debtorVoucherSignUrl,
            debtorVoucherProcessId: response.debtorVoucherProcessId
          });
        } else {
          this.setState({
            debtorVoucherSignUrl: '',
            debtorVoucherProcessId: ''
          });
        }
      })
      .catch(error => {
        this.setState({ debtorVoucherSignUrl: '', debtorVoucherProcessId: '' });
      });
  };

  initialValues = () => initialValuesSanitizer(this.props);
  _getLocation = (object, key, param, list) => {
    const result = object[key]
      ? this.props[list].find(
          location =>
            object[key] === location.description || object[key] === location.id
        )
      : '';
    if (param) {
      return result[param];
    }
    return result;
  };

  onSubmit = () => {
    const {
      process,
      isPromissoriesV2,
      externalProcessId,
      voucherSerial
    } = this.props;

    const { debtorVoucherProcessId } = this.state;
    if (process === 'remoteTeleshopping') {
      const {
        contract,
        verification_sale,
        observations,
        price,
        instalments,
        salesmanId
      } = this.props;

      this.props
        .checkDigitalSaleSignedUnmaterialized(debtorVoucherProcessId)
        .then(data => {
          if (data) {
            this.props.createRemoteTeleshopping({
              contract,
              verification_sale,
              observations,
              process,
              price,
              instalments,
              salesmanId,
              isPromissoriesV2,
              voucherSerial,
              externalProcessId,
              unmaterializedVoucherProcessId: debtorVoucherProcessId,
            });
          }
        });
    } else {
      this.voucherLastStep();
    }
  };

  voucherLastStep = () => {
    const { voucherSerial, process } = this.props;
    const { debtorVoucherProcessId } = this.state;

    const saleDetails = submitSanitizer(
      this.initialValues(),
      this.props,
      this._getLocation
    );

    this.props
      .checkDigitalSaleSignedUnmaterialized(debtorVoucherProcessId)
      .then(data => {
        if (data) {
          this.props.checkDigitalSaleSignedUnmaterializedVoucher(
            {
              unmaterialized_process_id: debtorVoucherProcessId,
              voucher_serial: voucherSerial,
              ...saleDetails
            },
            this.props.contract,
            this.props.routes[this.nextStep],
            process
          );
        }
      });
  };

  render() {
    const {
      classes,
      debtor,
      cosigner,
      isRemoteTeleshopping,
      clientMobile,
      cosignerUnmaterializedVoucherUrl,
      previewPromissoryLoading,
      requestSendOtpSent
    } = this.props;

    const { debtorVoucherSignUrl } = this.state;
    if (previewPromissoryLoading || requestSendOtpSent) {
      return <ActivityIndicator />;
    }
    if (debtorVoucherSignUrl && !this.state.debtorExternalTabOpened) {
      window.open(debtorVoucherSignUrl, '_blank');
      this.setState({ debtorExternalTabOpened: true });
    }

    const currentUser = {
      phone: isRemoteTeleshopping ? clientMobile : debtor.mobile
    };

    const cosignerUser = { phone: cosigner ? cosigner.mobile : null };

    return (
      <div className={classes.bodySection}>
        <Paper className={classes.paper}>
          <div className={classes.segmentHeaderOptions}>
            <SegmentHeader className={classes.segmentHeader}>
              {`Se le enviará un mensaje de texto ${
                cosigner ? 'a los números' : 'al número'
              } ${
                cosigner
                  ? currentUser.phone + ' y ' + cosignerUser.phone
                  : currentUser.phone
              } `}
            </SegmentHeader>
            {(this.props.requestSendOtpSent || !debtorVoucherSignUrl) && (
              <PrimaryButton
                onClick={this.fetchUnmaterializedVoucher}
                className={classes.button}
              >
                Firmar
              </PrimaryButton>
            )}
          </div>
          <div className={classes.item} variant="caption">
            {cosignerUnmaterializedVoucherUrl
              ? `El voucher está siendo firmado por los usuarios en este momento. Al
                  completar el proceso para ambos usuarios (deudor y codeudor), favor continuar presionando `
              : `El pagaré está siendo firmado por el usuario en este momento. Al
                  completar el proceso, favor continuar presionando `}
            <span className={classes.headline}>Siguiente</span>
            {` en esta pantalla`}
          </div>
          <StepperButtons onSubmit={this.onSubmit} goBack={this.props.goBack} />
        </Paper>
      </div>
    );
  }
}

const styles = theme => ({
  container: {
    display: 'flex'
  },
  paper: {
    flexGrow: 1,
    marginTop: '7px'
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  spacer: {
    flex: 1,
    minHeight: '1px',
    minWidth: '1px'
  },
  button: {
    alignSelf: 'flex-end',
    paddingLeft: 8 * theme.spacing.unit,
    paddingRight: 8 * theme.spacing.unit
  },
  segmentHeader: {
    marginTop: 3 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 2
    }
  },
  liDivider: {
    listStyleType: 'none'
  },
  item: {
    margin: 20,
    textAlign: 'center'
  },
  headline: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold'
  },
  segmentHeaderOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#f5f5f5'
  },
  signButton: {
    margin: 2,
    padding: '8px',
    marginRight: '20px'
  },
  pdf: {
    display: 'flex',
    justifyContent: 'center'
  },
  bottomOptions: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'center',
    marginTop: '7px'
  },
  segmentHeaderOtp: {
    marginTop: 3 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 5
    },
    width: '100%'
  },
  advisoryText: {
    textAlign: 'center'
  },
  iconRoot: {
    width: '70px',
    height: '70px'
  },
  imageIcon: {
    height: '70%'
  },
  segmentHeaderOtpV2: {
    marginTop: 3 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 5
    },
    width: '100%'
  },
  fontSize: '20px'
});

DigitalSaleOTPSale.propTypes = {
  classes: PropTypes.object.isRequired,
  newAlert: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(styles)(DigitalSaleOTPSale);
